import React, { useEffect, useRef } from 'react';
import { Col, Container, Row } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import TextFiltering from '../components/common/ag-grid/TextFiltering';
import AddOrganization from '../components/manage-organization/AddOrganization';
import GridOrganization from '../components/manage-organization/GridOrganization';
import ModalEditOrganization from '../components/manage-organization/ModalEditOrganization';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { getOrganizations, resetMessage } from '../redux/slices/organization';
import { getUsers } from '../redux/slices/user';
import { getBusinessTypeOptions, getOrganizationBaseOptions, getSteelCategoryOptions, getSteelMakerOptions } from '../redux/slices/options';
import type { AgGridReact as AgGridReactType } from 'ag-grid-react/lib/agGridReact';

const ManageOrganization = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { businessType, steelCategory, steelMaker, organizationBase } = useSelector((state: RootState) => state.options);
  const { hasError, serverMessage } = useSelector((state: RootState) => state.organization);
  const { users } = useSelector((state: RootState) => state.user);
  const { organizations } = useSelector((state: RootState) => state.organization);
  const gridRef = useRef<AgGridReactType>(null);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // 表示に使うためのデータを取得する
  useEffect(() => {
    dispatch(getBusinessTypeOptions());
    dispatch(getOrganizationBaseOptions());
    dispatch(getSteelCategoryOptions());
    dispatch(getSteelMakerOptions());
    dispatch(getUsers({}));
  }, []);

  // 初期データを取得する
  useEffect(() => {
    if (organizations === undefined && businessType.length > 0 && steelCategory.length > 0 && steelMaker.length > 0 && organizationBase.length > 0 && users && users.length > 0) {
      dispatch(getOrganizations());
    }
  }, [businessType, steelCategory, steelMaker, organizationBase, users]);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したとき
   */
  const dismiss = (): void => {
    dispatch(resetMessage());
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row id="pageTitle" noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('organization.manage')} subtitle="Manage Organization" className="text-sm-left" />
      </Row>

      <Notification theme={hasError ? 'danger' : 'success'} isOpen={serverMessage !== undefined && serverMessage.length > 0} message={serverMessage} dismissCallback={dismiss} />

      <Row className="mb-4">
        <Col md="3" sm="6">
          <TextFiltering gridRef={gridRef} />
        </Col>
        <Col md="3" sm="6">
          <AddOrganization />
        </Col>
      </Row>

      <GridOrganization ref={gridRef} />
      <ModalEditOrganization />
    </Container>
  );
};

export default ManageOrganization;
